import { createFileRoute, redirect } from '@tanstack/react-router'

// Root path: send authenticated users to /detect. The requireAuth gate in
// __root.tsx already enforces a session for non-public routes, so reaching
// this redirect means the session is valid.
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/detect' })
  },
})
